import axios from 'axios';

import { ENV_VARIABLES } from '@/constants';
import { setupAuthInterceptors } from '@/libs';

const apiPanorama = axios.create({
  baseURL: ENV_VARIABLES.PANORAMA_API_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
});

setupAuthInterceptors(apiPanorama);

export default apiPanorama;
